import { useCallback, useContext } from 'react';
import ModalContext from '~/contexts/ModalContext';

export function useOpenSoftPullModal() {
  const { setSoftPullModalOpen } = useContext(ModalContext);

  return useCallback(() => {
    setSoftPullModalOpen(true);
  }, [setSoftPullModalOpen]);
}
